import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { BadgeDiscountSolid as n$1 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/badge-discount-solid.es.es.js";
import { CoinsSolid as t$1 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/coins-solid.es.es.js";
import { DocumentListSolid as n$2 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/document-list-solid.es.es.js";
import { HandHoldingDollarCircleSolid as n } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/hand-holding-dollar-circle-solid.es.es.js";
import { InvoiceSolid as t } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/invoice-solid.es.es.js";
import { MoreHorizontalSolid as n$3 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/more-horizontal-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
const SEARCH_CARD_ICON_ID = "search-card-icon";
function CustomIconCard({
  type,
  color
}) {
  const iconsBasedOnType = {
    bonusAndEconomicContributions: /* @__PURE__ */ jsx(n, { "data-testid": SEARCH_CARD_ICON_ID, color }),
    deductionsAndFiscalBonus: /* @__PURE__ */ jsx(n$1, { "data-testid": SEARCH_CARD_ICON_ID, color }),
    fiscalDeclarationAnd730: /* @__PURE__ */ jsx(t, { "data-testid": SEARCH_CARD_ICON_ID, color }),
    certificatesAndSupportServices: /* @__PURE__ */ jsx(n$2, { "data-testid": SEARCH_CARD_ICON_ID, color }),
    financialServices: /* @__PURE__ */ jsx(t$1, { "data-testid": SEARCH_CARD_ICON_ID, color }),
    other: /* @__PURE__ */ jsx(n$3, { "data-testid": SEARCH_CARD_ICON_ID, color })
  };
  return iconsBasedOnType[type];
}
export {
  CustomIconCard
};
//# sourceMappingURL=CustomIconCard.es.js.map
